<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary print-hide">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">{{language?.delivery_report}}</h4>
          </span>

       

          <div class="d-flex align-items-center gap-2 ms-auto">

            <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas"
              data-bs-target="#orderDetailsCanvas" aria-controls="orderDetailsCanvas">
              <b class="bg-white   rounded-circle user-icon">
                <i class="bi bi-filter  d-flex m-1 h4 text-dark"></i>
              </b>
            </a>
          </div>

          
         
        </div>




      </div>

      <!-- body -->
  <!-- body -->
<div class="my-auto overflow-auto vh-100 pb-5">
  <div class="container bg_card">
    <div class="pt-2 row">
      <div class="col-12 pb-1">
        <!-- <h4>Report</h4> -->
        <!-- <input type="text" v-model="search_txt" placeholder="Search Customer Here" class="form-control"> -->
      </div>
      <div class="col-12 card mt-2" ref="captureArea">

        <div class="row">
          <div class="d-flex">
            <span v-if="CustomerName.name" class="me-3"><strong>Name: {{ CustomerName.name }}</strong></span>
            <span v-if="CustomerName.contact"><strong>Contact: {{ CustomerName.contact }}</strong></span>&nbsp;&nbsp;
            <span v-if="Fromdate"><strong>Fromdate: {{ Fromdate }}</strong></span>&nbsp;
            <span v-if="Todate"><strong>Todate: {{ Todate }}</strong></span>
          </div>
        </div>
        

        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Qty</th>
              <th>Delivered</th>
              <th>Pending</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, i) in filterereportList" :key="order.id">
              <td>{{ order.Product }}</td>
              <td>{{ order.Qty }}</td>
              <td>{{ order.Pending }}</td>
              <td>{{ order.Delivered }}</td>


            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="1" class="text-end"><strong>Total:</strong></td>
              <td class="text-primary"><strong> {{ totalqty }}</strong></td>
              <td class="text-primary"><strong> {{ totalPending }}</strong></td>
              <td class="text-primary"><strong> {{ totalDelivered }}</strong></td>

            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <div class="d-flex gap-1 justify-content-center print-hide">
      <!-- Print Button -->
        <div class="text-center mt-3">
        <button class="btn btn-secondary me-2" @click="printPage">
          <i class="bi bi-printer"></i> Print
        </button>
      </div>



     <!-- Capture & Share Button -->
     <div class="text-center mt-3">
      <button class="btn btn-primary" @click="captureView">
        <i class="bi bi-share"></i> Capture & Share
      </button>
      <!--<button class="btn btn-primary" style="margin-left: 5px;" @click="genratepdf">-->
      <!--  <i class="bi bi-share"></i> Genrate pdf-->
      <!--</button>-->
    </div>


    </div>


</div>


  
      <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="orderDetailsCanvas"
      aria-labelledby="orderLabel">
      <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
        <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
            class="bi bi-arrow-left fs-5 text-white"></i></a>
        <h6 class="offcanvas-title text-white m-0" id="orderLabel">Filter</h6>
      </div>
      <div class="offcanvas-body">
          <div class="col-12 row">

            <div class="col-12">
              <label>Customer Name</label>
              <select class="form-select form-select-sm" id="customers" ref="customers" v-model="filter.cust_id">
                <option value="0" disabled="" selected="">{{language?.select_cutomer}}</option>
                <option v-for="(item, index) in customers" :key="index" :value="item.id">{{ item.name }}</option>
              </select>
              <span class="text-danger">{{duelabel}}</span>
              </div>

              <div class="col-6 mt-2">
                  <label for="address m-0 p-0" class="form-label">From Date</label>
                  <input type="date" id="" v-model="filter.fromdate" class="form-control m-0 p-0" >
                
              </div> 
              <div class="col-6 mt-2">
                  <label for="address m-0 p-0" class="form-label">To date</label>
                  <input type="date" id="" v-model="filter.todate" class="form-control m-0 p-0" >    
              </div> 

  

              <div class="offcanvas-footer">
                <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
                <button class="btn btn-success col-12"  @click="filterallreportList">
                 <i class="bi bi-check"></i> &nbsp;Filter
               </button>
            </div>
  </div>
  </div>
          
    
    </div>
   


    
    </div>
  </div>
</template>
<style>
.float-right{
    float: right;
}
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
.custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
 }

@media print {
  .print-hide {
    display: none !important;
  }

  body {
    margin: 0;
  }

  table {
    font-size: 12px;
  }
}




</style>
<script>
import axios from "@/plugins/axios";
import { reactive } from "vue";
import html2canvas from "html2canvas";
 
  export default {
    name: 'Branch',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();
      this.getNewOrderBasics(); // Call the method here

    },

    computed: {

   totalqty() {
    return this.filterereportList.reduce(
      (sum, order) => sum + Number(order.Qty || 0),
      0
    );
  },

   totalPending() {
    return this.filterereportList.reduce(
      (sum, order) => sum + Number(order.Pending || 0),
      0
    ).toFixed(2);
     },

   totalDelivered() {
    return this.filterereportList.reduce(
      (sum, order) => sum + Number(order.Delivered || 0),
      0
    ).toFixed(2);
  },

  




    },

    watch: {
      search_txt(newVal) {
        this.filterereportList = this.reportList.filter((item) =>
          item.cust_name.toLowerCase().includes(newVal.toLowerCase())
        );
      },
       
    },
    data() {
      return { 
        loading: false,
        error: null,
        isUserLogged: false,
        user_details: [],
        reportList: [],
        productsCostList: [],
        filteredproductsCostList: [],
        filterereportList: [],
        selected: [],
        customers: [],
        CustomerName:[],
        guage:this.getLocalStorageArray('lang'),
        selected_services: {},
        order_products_services: {},
      
        filter:{
          fromdate:new Date().toISOString().split('T')[0],
          todate:new Date().toISOString().split('T')[0],
          cust_id:0
        },

        customer:{
          name:'',
          contact:'',
          address:'',
        },

        Fromdate:'',
        Todate:'',

        
        search_txt: '',

      }
    },
    methods: {
      initializeHomeContent() {


      },
      editBranch(editBranch) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
        //  this.branch=editBranch;
      },
      goBack() {
          
          this.$router.go(-1);
  },
             
      async getNewOrderBasics() {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("getdeliveryreportList").then((response) => {
            self.productsCostList = response.data.cost;
            self.servicesList = response.data.servicesLists;
            self.reportList = response.data.reportlist;
            self.filterereportList = self.reportList; 
            self.customers=response.data.customer;
            self.language=response.data.language;
            localStorage.setItem('lang',response.data.language);

          }).then(() => {
            self.initializeHomeContent();

            $("#customers").select2({
              width: '100%',
              placeholder: "Search Services Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.filter.cust_id= $(this).val(); 
                
            });
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },

 
  

      filterallreportList() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("filter_delivery_report",self.filter).then((response) => {
               
              self.reportList=response.data.reportlist;
              self.filterereportList = self.reportList; 
              self.Fromdate=response.data.fromdate;
              self.Todate = response.data.todate; 
              self.CustomerName=response.data.customer_name;
                       window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("orderDetailsCanvas")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

      async captureView() {
      const element = this.$refs.captureArea; // Select the element to capture

      html2canvas(element, { useCORS: true }).then((canvas) => {
        canvas.toBlob((blob) => {
          if (!blob) return;

          // Create a File object from the blob
          const file = new File([blob], "bill_print.png", { type: "image/png" });

          // Check if Web Share API is supported
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator
              .share({
                 title: "Order No: #"+self.order,
                  text: self.share_msg,
                files: [file],
              })
              .catch((err) => console.error("Sharing failed", err));
          } else {
            // Fallback to download if sharing is not supported
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Report.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }, "image/png");
      });
    },  


    getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },

      printPage() {
      window.print();
    }


   



    }
  }






</script>